import RouteContainer from 'containers/RouteContainer';
import Component from './containers/NPViewContainer';

import { editTitle } from 'lib/toolbar';

export const path = `/`;
export const navigation = { name: 'npView', id: 'npView.title', viewTitle: 'npView.title', editTitle };

export default RouteContainer(path, Component);
